import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React from 'react';
import modal from 'decorators/Modal/Modal';
export var ReservationModalUnwrapped =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ReservationModalUnwrapped, _React$Component);

  function ReservationModalUnwrapped(props) {
    var _this;

    _classCallCheck(this, ReservationModalUnwrapped);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReservationModalUnwrapped).call(this, props));
    _this.state = {
      loaded: false
    };
    return _this;
  }

  _createClass(ReservationModalUnwrapped, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleMessage = this.handleMessage.bind(this);
      window.addEventListener('message', this.handleMessage);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (__CLIENT__ || __TEST__) {
        window.removeEventListener('message', this.handleMessage);
      }
    }
  }, {
    key: "handleMessage",
    value: function handleMessage(event) {
      var eventName = event.data.eventName;

      if (eventName === 'resIframe:close' || eventName === 'resIframe:done') {
        this.props.onModalClose();
      } else if (eventName === 'resIframe:loaded') {
        this.setState({
          loaded: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("div", null, !this.state.loaded && React.createElement("div", {
        className: "preloader__wrapper"
      }, React.createElement("div", {
        className: "preloader"
      })), React.createElement("iframe", {
        src: "/reserve_class/".concat(this.props.classId),
        scrolling: "no",
        className: "modal__iframe",
        style: {
          display: this.state.loaded ? 'block' : 'none'
        },
        ref: function ref(ifr) {
          return _this2.iframe = ifr;
        }
      }));
    }
  }]);

  return ReservationModalUnwrapped;
}(React.Component);
ReservationModalUnwrapped.propTypes = {
  classId: PropTypes.number.isRequired,
  onModalClose: PropTypes.func.isRequired
};
export var Modal = modal({
  headerClass: 'modal--iframe'
})(ReservationModalUnwrapped);